import { CountryGroup } from './types';

export const countryGroups: CountryGroup[] = [
    {
        id: 'uae',
        name: 'United Arab Emirates',
        brokerIds: ['uae'],
    },
    {
        id: 'oman',
        name: 'Oman',
        brokerIds: ['salalah', 'oman'],
    },
    {
        id: 'jordan',
        name: 'Jordan',
        brokerIds: ['jordan', 'jordan-zarqa', 'jordan-aqaba'],
    },
    {
        id: 'poland',
        name: 'Poland',
        brokerIds: ['poland-warsaw'],
    },
    {
        id: 'ukraine',
        name: 'Ukraine',
        brokerIds: ['ukraine'],
    },
    {
        id: 'georgia',
        name: 'Georgia',
        brokerIds: ['georgia'],
    },
    {
        id: 'ghana',
        name: 'Ghana',
        brokerIds: ['accra', 'tema'],
        ghanaOnly: true,
    },
];
